<script setup>
/**
 * 「我的推广」页，逐条对齐旧版 web/12.0195d2b4b240a93b0284.js 里的
 * app-recommend 组件（类 o、模板工厂 _、样式 x）。
 * 旧版路由是 /tabs/recommend，同一模块下还有三个子页：
 *   qrcode → 我的二维码、team → 我的团队、money → 推广收益
 *
 * 这一页本身没有任何请求，就是三个入口：
 *   ion-header：ion-button[routerLink="/tabs/user"] + ion-title「我的推广」
 *   ion-content（没有 padding 属性）
 *     ion-list
 *       ion-item[routerLink="/tabs/recommend/money"]  > ion-label「 推广收益 」
 *       ion-item[routerLink="/tabs/recommend/team"]   > ion-label「 我的团队 」
 *       ion-item[routerLink="/tabs/recommend/qrcode"] > ion-label「 二维码 」
 *
 * 样式表 x 只有一条 ion-avatar{...}，模板里没用到，所以这页没有自定义样式。
 * 另外注意：旧版这三个 ion-item 没有 detail 属性，md 模式下不会显示右侧箭头。
 *
 * 「推广」这个 tab 在底部导航里是条件显示的（getConfig('game_recommend')），
 * 详见 AppBottomNav.vue。
 */
import AppBottomNav from '../components/AppBottomNav.vue'
</script>

<template>
  <div class="recommend-page">
    <!-- 旧版 ion-header > ion-toolbar，返回按钮 routerLink="/tabs/user" -->
    <header class="modal-header">
      <RouterLink class="modal-back" to="/user/profile" aria-label="返回">
        <svg class="modal-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor" /></svg>
      </RouterLink>
      <h1 class="modal-title">我的推广</h1>
      <span class="modal-spacer" aria-hidden="true"></span>
    </header>

    <div class="modal-content">
      <section class="ion-list">
        <RouterLink class="list-item" to="/user/recommend/money">
          <div class="list-item-inner"><div class="ion-label"> 推广收益 </div></div>
        </RouterLink>
        <RouterLink class="list-item" to="/user/recommend/team">
          <div class="list-item-inner"><div class="ion-label"> 我的团队 </div></div>
        </RouterLink>
        <RouterLink class="list-item" to="/user/recommend/qrcode">
          <div class="list-item-inner"><div class="ion-label"> 二维码 </div></div>
        </RouterLink>
      </section>
    </div>

    <!-- 旧版这一页是 tabs 的第三个 tab，所以带底部导航 -->
    <AppBottomNav />
  </div>
</template>

<style scoped>
/* 页面外壳与顶栏跟其它旧版还原页保持一致 */
.recommend-page{position:fixed;z-index:1;top:0;left:0;width:100%;height:100%;background:#fff;color:#000;display:flex;flex-direction:column;font:14px Arial,"Microsoft YaHei",sans-serif}
.modal-header{display:flex;align-items:center;height:56px;background:var(--legacy-theme,#f95454);color:var(--legacy-toolbar-color,#fff);position:relative;z-index:1;box-shadow:0 2px 4px rgb(0 0 0 / 20%)}
.modal-back{display:flex;align-items:center;justify-content:center;width:56px;height:56px;border:0;background:transparent;line-height:1;color:inherit;cursor:pointer;padding:0;text-decoration:none}
.modal-back .modal-icon{width:24px;height:24px;display:block}
.modal-title{flex:1;margin:0;font-size:18px;font-weight:500;text-align:center;color:inherit}
.modal-spacer{width:56px;flex:none}
/* 这一页 ion-content 没有 padding 属性；底部留出 tab 栏的 56px */
.modal-content{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding-bottom:56px}

/* --- Ionic 4 md 的真实默认值，取自 web/135.773ae5d979ae5c36fbef.js --- */
.ion-list{display:block;margin:0;padding:8px 0;background:#fff;list-style-type:none}
/* RouterLink 会渲染成 <a>，所以要显式改回块级并去掉链接色 */
.list-item{display:flex;align-items:center;justify-content:space-between;width:100%;min-height:48px;margin:0;padding:0 0 0 16px;background:#fff;color:#000;font-size:.8rem;overflow:hidden;position:relative;box-sizing:border-box;text-decoration:none}
.list-item-inner{display:flex;flex:1;flex-direction:inherit;align-items:inherit;align-self:stretch;min-height:inherit;padding:0 16px 0 0;border-width:0 0 1px 0;border-style:solid;border-color:rgba(0,0,0,.13);overflow:hidden;box-sizing:border-box}
.ion-label{display:block;font-size:inherit;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}
</style>
